import { render, staticRenderFns } from "./Charts.vue?vue&type=template&id=6ca91213"
import script from "./Charts.vue?vue&type=script&lang=js"
export * from "./Charts.vue?vue&type=script&lang=js"
import style0 from "./Charts.vue?vue&type=style&index=0&id=6ca91213&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca91213')) {
      api.createRecord('6ca91213', component.options)
    } else {
      api.reload('6ca91213', component.options)
    }
    module.hot.accept("./Charts.vue?vue&type=template&id=6ca91213", function () {
      api.rerender('6ca91213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/charts/Charts.vue"
export default component.exports